import dayjs from "dayjs"

/**
 * Date-span primitives shared by the booking total and the multi-day pricing helpers.
 *
 * These live in their own module because `multiDayPricing` imports the adjustment helpers from
 * `calculateBookingTotal`, so `calculateBookingTotal` cannot import back from it without creating
 * a cycle.
 */

/** Every ISO date from start to end inclusive. An unset or reversed range yields []. */
export const enumerateDates = (start, end) => {
  if (!start || !end) return []
  const first = dayjs(start).startOf("day")
  const last = dayjs(end).startOf("day")
  if (last.isBefore(first)) return []
  const dates = []
  for (let cursor = first; !cursor.isAfter(last); cursor = cursor.add(1, "day")) {
    dates.push(cursor.format("YYYY-MM-DD"))
  }
  return dates
}

/** Inclusive night-count-as-days: Aug 19 → Aug 21 is 3 days, matching how durations are sold. */
export const countDays = (start, end) => enumerateDates(start, end).length
